import React, { useState } from "react";
import ItemsCarousel from "react-items-carousel";
import nursingSch1 from "../asset/nursingSchool1.png";
import nursingSch2 from "../asset/nursingSchool2.png";
import nursingSch3 from "../asset/nursingSchool3.png";
import nursingSch4 from "../asset/nursingSchool4.jpg";
import nursingSch5 from "../asset/nursingSchool5.jpg";
import nursingSch6 from "../asset/nursingSchool6.jpg";

import { makeStyles } from "@mui/styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { Typography } from "./Typography";
import { MobileWeb } from "./mobile/BreakPoint";

const useStyles = makeStyles((theme) => ({
  imgBox: {
    width: "100%",
    height: "620px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      // display: "none",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      top: 60,
      position: "relative",
    },
  },
  carousel: {
    width: 645,
    height: 620,
    textAlign: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  mCarousel: {
    display: "none",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "block",
      textAlign: "center",
      width: "100%",
      height: "100%",
      maxHeight: 620,
      position: "relative",
      top: 40,
    },
  },
  mPosterImg: {
    width: 230,
    background: "#fff",
  },
}));

export const ItemCarousel2 = () => {
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const chevronWidth = 40;
  const classes = useStyles();

  return (
    <div>
      <div
        className={classes.carousel}
        style={{ padding: `0 ${chevronWidth}px` }}
      >
        <ItemsCarousel
          infiniteLoop
          requestToChangeActive={setActiveItemIndex}
          activeItemIndex={activeItemIndex}
          numberOfCards={1}
          gutter={20}
          outsideChevron
          chevronWidth={chevronWidth}
          leftChevron={
            <button
              cursor="pointer"
              style={{
                border: "none",
                backgroundColor: "transparent",
                cursor: "pointer",
              }}
            >
              <ArrowBackIosIcon
                style={{
                  fontSize: "80px",
                  position: "relative",
                  width: "80px",
                  color: "#c4c4c4",
                  top: 0,
                }}
              />
            </button>
          }
          rightChevron={
            <button
              style={{
                border: "none",
                backgroundColor: "transparent",
                cursor: "pointer",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "80px",
                  position: "relative",
                  width: "80px",
                  color: "#c4c4c4",
                  top: 0,
                  right: -15,
                }}
              />
            </button>
          }
        >
          <div className={classes.imgBox}>
            <img
              style={{ width: 250, height: 355 }}
              src={nursingSch1}
              alt="1"
            ></img>
            <Typography
              variant="body1"
              style={{ display: "block", textAlign: "center" }}
            >
              보도자료
            </Typography>
          </div>
          <div className={classes.imgBox}>
            <img style={{ width: "100%" }} src={nursingSch2} alt="2"></img>
            <Typography
              variant="body1"
              style={{ display: "block", textAlign: "center" }}
            >
              학생활동
            </Typography>
          </div>
          <div className={classes.imgBox}>
            <img style={{ width: "100%" }} src={nursingSch3} alt="2"></img>
            <Typography
              variant="body1"
              style={{ display: "block", textAlign: "center" }}
            >
              프로그램 활동 1
            </Typography>
          </div>
          <div className={classes.imgBox}>
            <img style={{ width: "100%" }} src={nursingSch4} alt="2"></img>
            <Typography
              variant="body1"
              style={{ display: "block", textAlign: "center" }}
            >
              프로그램 활동 2
            </Typography>
          </div>

          <div className={classes.imgBox}>
            <img style={{ width: "100%" }} src={nursingSch5} alt="2"></img>
            <Typography
              variant="body1"
              style={{ display: "block", textAlign: "center" }}
            >
              프로그램 활동 3
            </Typography>
          </div>
          <div className={classes.imgBox}>
            <img
              style={{ width: 250, height: 355 }}
              src={nursingSch6}
              alt="1"
            ></img>
            <Typography
              variant="body1"
              style={{ display: "block", textAlign: "center" }}
            >
              수료증
            </Typography>
          </div>
        </ItemsCarousel>
      </div>
      {/* 모바일 화면 Carousel */}
      <div className={classes.mCarousel}>
        <div>
          <ItemsCarousel
            infiniteLoop
            requestToChangeActive={setActiveItemIndex}
            activeItemIndex={activeItemIndex}
            numberOfCards={1}
            slidesToScroll={1}
            gutter={20}
            rightChevron={
              <ArrowForwardIosIcon
                type="right"
                style={{ top: 0, position: "relative" }}
              />
            }
            leftChevron={
              <ArrowBackIosIcon
                type="left"
                style={{ top: 0, position: "relative" }}
              />
            }
            chevronWidth={60}
          >
            {/* 모바일 1번 포스터 */}
            <div style={{ position: "relative" }}>
              <img
                src={nursingSch1}
                className={classes.mPosterImg}
                alt="poster1"
              />
              <Typography
                variant="body1"
                style={{ display: "block", textAlign: "center" }}
              >
                보도자료
              </Typography>
            </div>
            {/* 모바일 2번 포스터 */}
            <div style={{ position: "relative", top: 95 }}>
              <img
                src={nursingSch2}
                className={classes.mPosterImg}
                alt="poster2"
              />
              <Typography
                variant="body1"
                style={{ display: "block", textAlign: "center" }}
              >
                학생활동
              </Typography>
            </div>
            {/* 모바일 3번 포스터 */}
            <div style={{ position: "relative", top: 95 }}>
              <img
                src={nursingSch3}
                className={classes.mPosterImg}
                alt="poster3"
              />
              <Typography
                variant="body1"
                style={{ display: "block", textAlign: "center" }}
              >
                프로그램 활동 1
              </Typography>
            </div>
            {/* 모바일 4번 포스터 */}
            <div style={{ position: "relative", top: 95 }}>
              <img
                src={nursingSch4}
                className={classes.mPosterImg}
                alt="poster4"
              />
              <Typography
                variant="body1"
                style={{ display: "block", textAlign: "center" }}
              >
                프로그램 활동 2
              </Typography>
            </div>
            {/* 모바일 5번 포스터 */}
            <div style={{ position: "relative", top: 95 }}>
              <img
                src={nursingSch5}
                className={classes.mPosterImg}
                alt="poster4"
              />
              <Typography
                variant="body1"
                style={{ display: "block", textAlign: "center" }}
              >
                프로그램 활동 3
              </Typography>
            </div>
            {/* 모바일 6번 포스터 */}
            <div style={{ position: "relative" }}>
              <img
                src={nursingSch6}
                className={classes.mPosterImg}
                alt="poster4"
              />
              <Typography
                variant="body1"
                style={{ display: "block", textAlign: "center" }}
              >
                수료증
              </Typography>
            </div>
          </ItemsCarousel>
        </div>
      </div>
    </div>
  );
};
